import api from '@/api';

const state = {
  teams: []
};

const mutations = {};

const actions = {
  get(context, payload) {
    console.log('currentTeamLoad');
  },

  getAll() {
    console.log('get all teams based on member');
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
